// import { toast } from 'react-toastify';
import { DiscountType } from "../enums/discount-type.enum";
import { CustomerAccount } from "../store/slices/customer/types";
import { PromoCodeData } from "../store/slices/organisation/types";
import { Product } from "../store/slices/order/types";
import { getFromSessionStorage } from "./browserStorage";
import { jwtDecode } from "jwt-decode";
// import { getProductTotal, getAllProducts } from '../components/modalOperations/CartSharedFunctions';
// import { uuid } from 'uuidv4';
import { nanoid } from "nanoid";
// const CryptoJS = require('crypto-js');
// const passphrase = process.env.PASSPHRASE_CODE;

// export const featureFlag = {
//     isFreqAvailable: false,
//     externalCustomerBooking: false,
//     cancelOrder: false,
//     takeQuiz: false,
//     isCovid: false,
//     viewCustomerOrder: true,
//     shareWithDoctor: false,
//     reOrder: false,
//     sessionTimeout: false,
//     inviteFriend: false,
//     isVercelProduction: true
// };

export const CurrencySign = "₦";

// export const SampleCollectionFee = 5000;

// export const CovidTestSpecial = {
//     covidLagos: 'Covid PCR Lagos',
//     covidAbuja: 'Covid PCR Abuja',
//     hpvSelfSamplingKit: 'HPV Self-Sampling Kit'
// };

// export const BaseURL = process.env.APP_BASE_URL;
export const S3_BUCKET =
  "https://healthtracka-s3-bucket.s3.eu-west-2.amazonaws.com/";

export const LOGGER = (
  key: string,
  value: any,
  isProd = process.env.NODE_ENV === "production"
) => {
  if (isProd) {
    return;
  }
  // eslint-disable-next-line no-console
};

// // // Encrypting Security of User Profile
// // export const EncryptUserDetails = (value) => {
// //     const stringifyValue = JSON.stringify(value);
// //     return CryptoJS.AES.encrypt(stringifyValue, passphrase).toString();
// // };

// // // Decrypting and retrieving User Profile Object
export const GET_USER_TOKEN = () => {
  const getFromStorage = getFromSessionStorage("accessToken");
  if (!getFromStorage) {
    return;
  }
  return getFromStorage;
  // const profileByteDecrypt = CryptoJS.AES.decrypt(getFromStorage, passphrase);
  // const toOriginalString = profileByteDecrypt.toString(CryptoJS.enc.Utf8);
  // return toOriginalString ? JSON.parse(toOriginalString) : null;
};

// // export const CopierHelper = (obj, id, text) => {
// //     if (obj !== null) {
// //         const doc = document.getElementById(id);
// //         doc.focus();
// //         doc.select();
// //         document.execCommand('copy');

// //         navigator.clipboard.writeText(doc.value);

// //         toast.info(`${text} copied`);
// //     } else {
// //         toast.error('Failed to copy to clipboard, try again later');
// //     }
// // };

// // export const copyToClipboard = async (value, title) => {
// //     try {
// //         await navigator.clipboard.writeText(value);

// //         toast.success(title ? `${title} copied` : `Text copied!`);
// //     } catch (error) {
// //         toast.error('Failed to write to clipboard, try again later');
// //     }
// // };

export const formatAmount = (num: any) => {
  if (num) {
    const initial = parseFloat(num).toFixed(0);
    return initial.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

// // export const formatNumber = (num) => {
// //     if (!num) {
// //         return;
// //     }
// //     return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
// // };

// // export const dateFormatterHandler = (dateStr, format = 'DD-MM-YYYY') => {
// //     if (!dateStr) {
// //         return undefined;
// //     }
// //     return moment(dateStr, format, true).isValid() ? moment(dateStr, format, true) : undefined;
// // };

// // export const GetFromNowDate = (dateValue, stringFormat, fromNow, format = 'DD-MM-YYYY') => {
// //     if (moment(dateValue, stringFormat).isValid()) {
// //         if (fromNow) {
// //             return moment(dateValue).fromNow();
// //         }
// //         return moment(dateValue, stringFormat).format(format);
// //     }
// //     return '';
// // };

// // export const GetNumberOfDaysInDates = (startdate, enddate) => {
// //     if (startdate === undefined && enddate === undefined) {
// //         throw new Error('Date not provided');
// //         // return;
// //     }
// //     const start = moment(startdate, 'YYYY-MM-DD');
// //     const end = moment(enddate, 'YYYY-MM-DD');
// //     return Math.abs(moment.duration(start.diff(end)).asDays());
// // };

export const generateString = () => {
  const uniqueId = nanoid();
  return uniqueId;
};

// // export const ConvertToSlug = (string) => {
// //     let formattedSlug = '';
// //     const format = string?.replace(/[^a-zA-Z0-9]/g, '-')?.toLowerCase();
// //     const getFirstCharacter = format?.charAt(0);
// //     if (getFirstCharacter === '-') {
// //         formattedSlug = format?.substring(1);
// //     } else {
// //         formattedSlug = format;
// //     }
// //     return formattedSlug;
// // };

// // export const formatDateObjectHandler = (dateObj, format = 'YYYY-MM-DD') => {
// //     if (!dateObj) {
// //         return undefined;
// //     }
// //     if (!moment.isMoment(dateObj)) {
// //         return moment(dateObj).format(format);
// //     }
// //     return dateObj.format(format);
// // };

// // // TO REDUCE STRING LENGTH
// // export const truncateText = (string = '', length = '30', ending = '...') => {
// //     if (!(string && length)) {
// //         return;
// //     }
// //     return length > string.length ? string : string.substring(0, length - ending.length) + ending;
// // };

// // export const capitalize = (val) => {
// //     return val.charAt(0).toUpperCase() + val.slice(1);
// // };

// // export const findAllTotal = (list, isAmount = true) => {
// //     if (!Array && list === undefined) {
// //         return 0;
// //     }
// //     if (list !== undefined && list.length > 0) {
// //         return list.reduce((a, b) => a + parseFloat(b), 0);
// //     }
// //     return isAmount ? '0.00' : '0';
// // };

// // export const isEmpty = (obj) => {
// //     for (const key in obj) {
// //         if (Object.prototype.hasOwnProperty.call(obj, key)) {
// //             return false;
// //         }
// //     }
// //     return true;
// // };

// // export const scrollToTop = () => {
// //     window.scrollTo(0, 0);
// // };

// // export const customizeUploadPath = (path, file) => {
// //     const ext = file.type.split('/')[1];
// //     return path + '.' + ext;
// // };

// // export const readableFormatDate = (date) => {
// //     const REFERENCE = moment(date);
// //     // const TODAY = REFERENCE.clone().startOf('day');
// //     const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');

// //     const isToday = (momentDate) => {
// //         return moment().isSame(momentDate, 'd');
// //     };

// //     const isYesterday = (momentDate) => {
// //         return moment(momentDate).isSame(YESTERDAY, 'd');
// //     };

// //     if (isToday(date)) return 'TODAY';

// //     if (isYesterday(date)) return 'YESTERDAY';

// //     return REFERENCE.format('Do MMM, YYYY');
// // };

// // //calculate age
// // export const calculateAge = (birthDateString) => {
// //     const today = new Date();
// //     const birthDay = new Date(birthDateString);
// //     let age = today.getFullYear() - birthDay.getFullYear();
// //     const m = today.getMonth() - birthDay.getMonth();
// //     if (m < 0 || (m === 0 && today.getDate() < birthDay.getDate())) {
// //         age--;
// //     }
// //     return age;
// // };

// // export const getIndividualProductWithDiscount = (carts, productUniqueId) => {
// //     const allProducts = carts.map((cart) => cart.products).flat();
// //     const allPanels = allProducts.map((product) => product.panels).flat();
// //     const productWithDiscount = allPanels.find((panel) => panel?.uniqueId === productUniqueId);
// //     return productWithDiscount;
// // };

// // //calculate Order Discount
// // export const calculateOrderDiscountAmount = (promoCodeResponse, carts) => {
// //     if (promoCodeResponse.voucher?.discountType === 'Percentage') {
// //         if (promoCodeResponse.voucher?.voucherType?.toLowerCase() === 'individual') {
// //             const productWithDiscount = getIndividualProductWithDiscount(
// //                 carts,
// //                 promoCodeResponse?.voucher?.productUniqueId
// //             );
// //             if (productWithDiscount) {
// //                 return (promoCodeResponse?.voucher?.discountValue / 100) * productWithDiscount?.price;
// //             }
// //         }

// //         if (promoCodeResponse.voucher?.voucherType?.toLowerCase() === 'general') {
// //             return (promoCodeResponse?.voucher?.discountValue / 100) * getProductTotal(carts);
// //         }
// //     }

// //     if (promoCodeResponse?.voucher?.discountType === 'Amount') {
// //         return promoCodeResponse?.voucher?.discountValue;
// //     }

// //     return 0;
// // };

// // //event helpers
// // const eventTypes = ['keypress', 'mousemove', 'mousedown', 'scroll', 'touchmove', 'pointermove'];

// // export const addEventListener = (listener) => {
// //     eventTypes.forEach((type) => {
// //         window.addEventListener(type, listener, false);
// //     });
// // };

// // export const removeEventListeners = (listener) => {
// //     if (listener) {
// //         eventTypes.forEach((type) => {
// //             window.removeEventListener(type, listener, false);
// //         });
// //     }
// // };

// // export const checkAgent = () => {
// //     let isMobile;
// //     if (typeof window === 'undefined') return;
// //     isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
// //     // isMobile = navigator.userAgentData.mobile;
// //     return isMobile;
// // };

// // export const formatMobile = (mobileObj) => {
// //     if (mobileObj?.code === '234') {
// //         let newRawMobile = mobileObj.rawMobile
// //         while (newRawMobile?.charAt(0) === '0') {
// //             newRawMobile = newRawMobile.substring(1);
// //         }
// //         const newMobileObj = { ...mobileObj, rawMobile: newRawMobile };
// //         return newMobileObj;
// //     }
// //     return mobileObj;
// // };

// // export const isFlorishCare = (cartLists) => {
// //     return cartLists[0]?.subscriptionType === 'FlourishCarePlanSubscription';
// // };

// // export function formatDateToCustomString(dateString) {
// //     const date = new Date(dateString);

// //     const options = {
// //         year: 'numeric',
// //         month: 'long', // Full month name
// //         day: '2-digit' // Two-digit day of the month
// //     };

// //     const formattedDate = date.toLocaleDateString('en-US', options).toUpperCase();
// //     return formattedDate;
// // }

// // export const blogCategories = {
// //     47: {
// //         id: 47,
// //         name: 'Announcement'
// //     },
// //     1: {
// //         id: 1,
// //         name: 'General Health'
// //     },
// //     48: {
// //         id: 48,
// //         name: 'Healthtracka Updates'
// //     },
// //     3: {
// //         id: 3,
// //         name: "Men's Health"
// //     },
// //     4: {
// //         id: 4,
// //         name: "Women's Health"
// //     }
// // };

export const nairaFormatter = new Intl.NumberFormat("en-NG", {
  style: "currency",
  currency: "NGN",
});

// // const oneOffPaymentPlan = {
// //     id: 104569,
// //     name: '12  Months Subscription',
// //     label: 'Every 12 months',
// //     uniqueId: 'PAYMENTPLAN16355'
// // };

// // const threeMonthsPaymentPlan = {
// //     id: 104568,
// //     uniqueId: 'PAYMENTPLAN16352',
// //     label: 'Every 3 months',
// //     name: '3 months subscription'
// // };

// // const sixMonthsPaymentPlan = {
// //     id: 104570,
// //     name: '6 Months Subscription',
// //     label: 'Every 6 months',
// //     uniqueId: 'PAYMENTPLAN16354'
// // };

// // export const getDefaultPaymentPlan = (product) => {
// //     const fullBodyCheckupUniqueIds = ['PROD00019', 'PROD00020', 'PROD00021', 'PROD00022'];
// //     let defaultPlan = oneOffPaymentPlan;
// //     // for flourish care or sexual health
// //     const isSTI = product?.categories.some(
// //         (category) => category?.name === 'Sexual Health' || category?.uniqueId === 'CATEGORY00003'
// //     );
// //     if (product?.isFlourishCarePlan || isSTI) {
// //         defaultPlan = threeMonthsPaymentPlan;
// //     }
// //     // for full body checkup
// //     if (fullBodyCheckupUniqueIds.includes(product?.uniqueId)) {
// //         defaultPlan = sixMonthsPaymentPlan;
// //     }
// //     return defaultPlan;
// // };

export const getMainProfile = (accountData: CustomerAccount | null) => {
  if (accountData?.users && accountData?.users?.length > 0) {
    return accountData?.users.find((user) => user.isMainProfile);
  }
  return null;
};

export const getItemPromoPrice = (
  item: Product,
  promoCodeData: PromoCodeData
) => {
  const discountedProduct = promoCodeData?.voucher?.products?.find(
    (product) => product?._id === item?._id
  );
  if (!discountedProduct) {
    return {
      discount: 0,
      priceAfterDiscount: item?.price,
    };
  }

  const discount =
    promoCodeData.voucher?.discountType === DiscountType.Percentage
      ? (promoCodeData?.voucher?.discountValue / 100) * discountedProduct?.price
      : (promoCodeData?.voucher?.discountValue as number);

  const priceAfterDiscount = discountedProduct.price - discount;

  return {
    discount,
    priceAfterDiscount,
  };
};

export const isNumber = (value: any): boolean => {
  return !isNaN(value) && !isNaN(parseFloat(value));
};

export const validateToken = (token: string) => {
  if (!token) return false;
  const decoded = jwtDecode(token);
  const currentTime = Date.now();
 
  if (decoded.exp && decoded.exp * 1000 <= currentTime) {
    return true;
  } else {
    return false;
  }
};
